export const UpdateSessions = (val) => {
    return {
        type: 'UPDATE_SESSIONS',
        value: val
    };
}

export const UpdateOrder = (val) => {
    return {
        type: 'UPDATE_ORDER',
        value: val
    };
}

export const UpdateBreakBtns = (val) => {
    return {
        type: 'UPDATE_BREAKBTNS',
        value: val
    };
}